import { useEffect } from "react";
import { DIGITAL_BILLING_URL } from "../../utils/digitalBilling";

const RedirectToDigitalBilling = () => {
  useEffect(() => {
    window.location.replace(DIGITAL_BILLING_URL);
  }, []);

  return null;
};

export default RedirectToDigitalBilling;
